export type CheckoutPageThemeType = "Light" | "Dark";

export interface ICheckoutDisplaySettingsData {
    theme: CheckoutPageThemeType;
    logo: ICheckoutLogoDataModel;
}

export interface ICheckoutLogoDataModel {
    preferredLogoId?: string | null;
    linkData: ICheckoutLinkData;
}

export interface ICheckoutLinkData {
    link: string | null;
    target: string | null;
    fileId: string | null;
}

export interface ICheckoutPaymentSettingsData {
    enableGiftCards: boolean;
    enablePromoCode: boolean;
}

export type CheckoutPolicyType = "Return" | "Product" | "ContactUs" | "Custom";

export enum CheckoutPolicySourceType {
    Autogenerated = "Autogenerated",
    ExistingWebPage = "ExistingWebPage",
    Url = "Url"
}

export interface ICheckoutPolicy {
    isEnabled: boolean;
    name: string;
    pageId?: string | null;
    url?: string | null;
    policyType: CheckoutPolicyType;
    sourceType: CheckoutPolicySourceType;
}

export interface ICheckoutPoliciesSettingsData {
    policies: ICheckoutPolicy[];
    otherPolicies: ICheckoutPolicy[];
}

export interface ICheckoutPagesSettingsData {
    display: ICheckoutDisplaySettingsData;
    payment: ICheckoutPaymentSettingsData;
    policies: ICheckoutPoliciesSettingsData;
}